import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Container, Spinner, Button, Form } from "react-bootstrap";

import PageTitle from "../../../common/PageTitle";
import { withRouter } from "react-router-dom";
import Select from "react-select";

import {
  getUser,
  resetUser,
  handleInputChange,
  upsertAdminUserInfo,
} from "../../../store/actions/users/usersActions";
import { fetchRoles } from "../../../store/actions/roles/rolesActions";

class UserForm extends Component {
  constructor(props) {
    super(props);
    this.pathname = this.props.location.pathname;
    this.title = "Create User Admin";
    this.isReady = false;
    this.mode = "create";
  }

  componentDidMount() {
    this.props.resetUser();

    if (this.pathname === "/settings/admins/edit") {
      this.title = "Edit Admin User";
      this.mode = "edit";
      const urlParams = new URLSearchParams(this.props.location.search);
      const userId = urlParams.get("id");
      this.props.getUser(userId);
    }
  }

  validateEmail = (email) => {
    // Regular expression for validating an Email
    const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailReg.test(email);
  };

  handleEmailChange = (e) => {
    const newEmail = e.target.value;
    this.props.handleInputChange(null, { email: newEmail });
  };

  handleEmailBlur = (e) => {
    const newEmail = e.target.value;

    // Check if the email is valid only when the input field loses focus
    if (!this.validateEmail(newEmail) && newEmail !== "") {
      // If not valid, reset the email to the previous valid value or an empty string
      this.props.handleInputChange(null, { email: this.props.users.user.email || "" });
    }
  };
  
  renderUserForm = (user) => {
    const isEmailValid = this.validateEmail(user?.email);

    return (
      <Container>
        <Row className="mt-3">
          <Form.Group controlId="formAdminFirstName">
            <Form.Label className="waa-form-label" htmlFor="first_name">
              First Name
            </Form.Label>
            <Form.Control
              type="text"
              value={user?.first_name ?? null}
              onChange={(e) => {
                this.props.handleInputChange(null, {
                  first_name: e.target.value,
                });
              }}
            />
          </Form.Group>
        </Row>

        <Row className="mt-3">
          <Form.Group controlId="formAdminLastName">
            <Form.Label className="waa-form-label" htmlFor="last_name">
              Last Name
            </Form.Label>
            <Form.Control
              type="text"
              value={user?.last_name ?? null}
              onChange={(e) => {
                this.props.handleInputChange(null, {
                  last_name: e.target.value,
                });
              }}
            />
          </Form.Group>
        </Row>

        <Row className="mt-3">
          <Form.Group controlId="formAdminFirstName">
            <Form.Label className="waa-form-label" htmlFor="email">
              Email
            </Form.Label>
            <Form.Control
              type="text"
              disabled={this.mode !== "create"}
              value={user?.email ?? null}
              onChange={this.handleEmailChange}
              onBlur={this.handleEmailBlur}
              isInvalid={!isEmailValid}
            />
            <Form.Control.Feedback type="invalid">
              Please enter a valid email address.
            </Form.Control.Feedback>
          </Form.Group>
        </Row>

        <Row className="mt-3">
          <div className="float-right">
            <Button
              className="btn btn-default"
              onClick={() => {
                this.props.history.push("/settings/admins");
              }}
            >
              Cancel
            </Button>
            &nbsp;
            <Button
              onClick={() => {
                this.props.upsertAdminUserInfo(() => {
                  this.props.history.push("/settings/admins");
                });
              }}
            >
              {" "}
              Save{" "}
            </Button>
          </div>
        </Row>
      </Container>
    );
  };

  render() {
    let user = null;

    if (!this.isReady && this.pathname !== "/settings/admins/edit") {
      this.isReady = true;
    } else {
      user = this.props.users.user;
      this.isReady = true;
    }

    return this.isReady ? (
      <Container className="waa-container container mb-3">
        <PageTitle pageName={this.title} />
        <Row className="mb-3">
          <Col xs={6} sm={6} md={6} lg={6} xl={6}>
            {this.renderUserForm(user)}
          </Col>
        </Row>
      </Container>
    ) : (
      <Spinner animation="border" si ze="sm" />
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.users,
  roles: state.roles,
});

const mapDispatchToProps = (dispatch) => ({
  getUser: (...args) => dispatch(getUser(...args)),
  resetUser: () => dispatch(resetUser()),
  fetchRoles: () => dispatch(fetchRoles()),
  handleInputChange: (...args) => dispatch(handleInputChange(...args)),
  upsertAdminUserInfo: (...args) => dispatch(upsertAdminUserInfo(...args)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserForm)
);
